import React from 'react';
import cx from 'classnames';
import { NavLink } from 'react-router-dom';

const MenuItem = ({ to, sideInfo, children }) => {
  return (
    <NavLink
      className={cx('menu-item', {
        show: !!children,
      })}
      activeClassName="menu-item__active"
      to={to}
    >
      <div
        className={cx('menu-item__text', {
          show: !!children,
        })}
      >
        {children}
      </div>
      {!!sideInfo && sideInfo}
    </NavLink>
  );
};

export default MenuItem;
